export const loginType = {
    loginCookieName: "singin"
}